module Environments {
    "use strict";

    export class AgentsService implements IAgentService {
        static $inject = ["$http", "BootstrapDataService", "notifications"];

        constructor(private $http: ng.IHttpService, private bootstrapDataService: any, private notifications: INotifications) {

        }
        private requestCallback(response) {
            return response.data.success ? response.data : false;
        };

        public get(agent: IAgent) {
            return this.$http.get(agent.editUrl).then(this.requestCallback);
        };

        public getEvents(agentName, agentGroupName, environmentName, page) {
            var postData = {
                agentName: agentName,
                agentGroupName: agentGroupName,
                environmentName: environmentName,
                page: page,
                itemsPerPage: 25
            };
            return this.$http.post(this.bootstrapDataService.getAgentEventsUrl, postData).then(this.requestCallback);
        };

        public getTriggers(agentName, agentGroupName) {
            var postData = {
                agentName: agentName,
                agentGroupName: agentGroupName
            };
            return this.$http.post(this.bootstrapDataService.getAgentTriggersUrl, postData).then(this.requestCallback);
        };

        public save(agent: IAgent) {
            return this.$http.post(this.bootstrapDataService.saveAgentUrl, agent).then(this.requestCallback);
        };

        public remove(agent: IAgent) {
            return this.$http.get(agent.deleteUrl).then(this.requestCallback);
        };

        public getNewAgent(environment, agentGroup, isGateway: boolean) {
            return this.$http.post(this.bootstrapDataService.getNewAgentUrl, { environmentName: environment.name, agentGroupName: agentGroup.name, isGateway: isGateway}).then(this.requestCallback);
        };

        public download(agentId) {
            var link = document.createElement("a");
            link.setAttribute("href", this.bootstrapDataService.downloadAgentUrl + "?id=" + agentId);
            link.click();
        };
    }

    module.service("AgentsService", AgentsService);
}